module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/YavMR1/images/9781617508349_FrontCover.jpg?1684514922015",
      "alt": "This image is the cover for the book Arco Iris"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Arco Iris\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Sarah Vap’s newest book is a stunning collection of beautiful and frightening poemsIn her latest collection, Arco Iris, Sarah Vap explores race, tourism, market, history, intimacy, and the vulnerability of lives beneath the stamp of longstanding powers. Whiteness is considered through the action of travel in South America where white bodies disappear, or are invisible, or attempt to become irrelevant, or are impossible to destroy. These hallucinatory poems explore the subtle violence beneath the commonplace in a foreign land, a violence which underscores the naiveté of the traveler. As she writes in the haunting poem, “Trace”: The white and gold // fairy dust left of some spent bomb / settles // to the eyes of three children cuddling / in their hammock, belly-level of our boat.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sarah Vap\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("SARAH VAP is the author of Dummy Fire, winner of the 2006 Saturnalia Books Poetry Prize, selected by Forrest Gander. Her second collection, American Spikenard, was the winner of the Iowa Poetry Prize in 2006. Her most recent collection is Faulkner’s Rosary, published by Saturnalia Books in 2010. She is currently completing a Ph.D. at the University of Southern California, and lives in Santa Monica.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Saturnalia Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0